import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const EditProviderDialog = ({ open, onOpenChange, provider, setProvider, onSubmit }) => {
  if (!provider) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="surface-card max-w-2xl">
        <DialogHeader>
          <DialogTitle>Edit Medical Provider</DialogTitle>
          <DialogDescription>Update provider information</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="edit-provider-name">Name</Label>
            <Input id="edit-provider-name" value={provider.name} onChange={(e) => setProvider({ ...provider, name: e.target.value })} required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="edit-specialty">Specialty / Department</Label>
            <Input id="edit-specialty" value={provider.specialty || ''} onChange={(e) => setProvider({ ...provider, specialty: e.target.value })} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="edit-phone">Phone</Label>
              <Input id="edit-phone" type="tel" value={provider.phone || ''} onChange={(e) => setProvider({ ...provider, phone: e.target.value })} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="edit-email">Email</Label>
              <Input id="edit-email" type="email" value={provider.email || ''} onChange={(e) => setProvider({ ...provider, email: e.target.value })} />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="edit-address">Address</Label>
            <Textarea id="edit-address" value={provider.address || ''} onChange={(e) => setProvider({ ...provider, address: e.target.value })} className="resize-none" rows={2} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="edit-notes">Notes</Label>
            <Textarea id="edit-notes" value={provider.notes || ''} onChange={(e) => setProvider({ ...provider, notes: e.target.value })} className="resize-none" rows={2} />
          </div>
          <Button type="submit" className="w-full btn-primary">Save Changes</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditProviderDialog;
